import { House, Apartment, WithContext, VideoObject } from 'schema-dts';
import { Kfh_PropertyTypeInterface } from '../types/graphqlTypes';

type Property = House | Apartment;
export const getPropertySchema = (property: Kfh_PropertyTypeInterface) => {
  const schema: WithContext<any>[] = [];
  const schemaProperty: WithContext<Property> = {
    '@context': 'https://schema.org',
    '@type': property.propertyType.toLowerCase() === 'flat' ? 'Apartment' : 'House',
    name: `${property.address?.streetname}, ${property.address?.town} ${property.address?.outwardCode}`,
    description: property.salesDetails,
    numberOfRooms: property.bedrooms,

    floorSize: {
      '@type': 'QuantitativeValue',
      value: property.totalFloorArea,
      unitCode: 'SQF',
    },
    numberOfBathroomsTotal: property.bathrooms,
    numberOfBedrooms: property.bedrooms,
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'GB',
      addressLocality: property.address?.town,
      addressRegion: property.address?.region,
      postalCode: property.address.outwardCode,
      streetAddress: property.address?.streetname,
    },
    latitude: property.latitude,
    longitude: property.longitude,
  };
  if (property.floorLevel) {
    schemaProperty.floorLevel = property.floorLevel;
  }
  schema.push(schemaProperty);

  if (property.virtualViewingsUrl) {
    const videoSchema: WithContext<VideoObject> = {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      contentUrl: property.virtualViewingsUrl,
      uploadDate: property.createdDate,
      thumbnailUrl: `${process.env.GATSBY_FRONTEND_URL}${property?.firstImage?.localFile?.resize?.src}`,
      name: `${property.address?.streetname}, ${property.address?.town} ${property.address?.outwardCode} Video Tour`,
      description: `${property.address?.streetname}, ${property.address?.town} ${property.address?.outwardCode} Video Tour`,
    };
    schema.push(videoSchema);
  }

  return schema;
};
